import {
  ControlledStateOverrideProps,
  Filter
} from "react-table";
import * as _ from "lodash";
import moment from "moment-timezone";
import dot from "dot-object";

import {
  Filters,
  PaginatedParams,
  SortType
} from "../apiTypes";

export const formatPaginationObject = <T>(state: ControlledStateOverrideProps, defaultPagination?: PaginatedParams<T>): PaginatedParams<T> => {
  let sort: SortType<T> = defaultPagination ? defaultPagination.sort : [ [ "id", "DESC" ] ];

  if (state.sorted.length) {
    let sortedId = state.sorted[ 0 ].id;

    // TODO: This is quite hacky... change it to a proper solution.
    if (sortedId === "orderStatus") {
      sortedId = "orderStatusId";
    }

    sort = [ [ sortedId, state.sorted[ 0 ].desc ? "DESC" : "ASC" ] ];
  }

  return {
    page: state.page || 0,
    limit: state.pageSize || 0,
    offset: state.page && state.pageSize ? state.pageSize * state.page : 0,
    sort
  };
};

export const formatFilterObject = <T>(filters: Filter[], currentFilters?: any): Filters<T> => {
  const formattedFilters: Filters<T> = {};

  // If there are no filters, simply return with an empty object
  if (filters.length === 0) {
    return currentFilters || {};
  }

  // Set each filter object accordingly
  _.forEach(filters, filter => {
    // @ts-ignore
    formattedFilters[ filter.id ] = { $like: `%${filter.value}%` };

    if (typeof filter.value === "object") {
      if (filter.value.from) {
        const startDate = moment
          .utc(filter.value.from)
          .startOf("day")
          .toDate();

        const endDate =
          filter.value.to ||
          moment
            .utc(filter.value.from)
            .endOf("day")
            .toDate();

        // @ts-ignore
        formattedFilters[ filter.id ] = { $between: [ startDate, endDate ] };
      }
    }

    if (filter.id === "orderStatus") {
      if (filter.value) {
        // @ts-ignore
        formattedFilters[ filter.id ] = { id: filter.value };
      }
    }

    if (filter.id === "paymentStatus") {
      if (filter.value) {
        // @ts-ignore
        formattedFilters[ filter.id ] = filter.value;
      }
    }

    if (filter.id === "credit_exported") {
      if (filter.value) {
        // @ts-ignore
        formattedFilters[ "exported" ] = filter.value;
        delete formattedFilters[ "credit_exported" ];
      }
    }
  });
  dot.object(formattedFilters);

  // Override the currentFilters values with our new formattedFilters
  return {
    ...currentFilters,
    ...formattedFilters
  };
};
